import React from "react";
import { Link } from "react-router-dom";

import { LEGAL_CONFIG } from "../legal/legal-config";

const Footer: React.FC = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <nav className="site-footer__links" aria-label="Dokumenty">
          <Link to="/regulamin">Regulamin</Link>
          <Link to="/prywatnosc">Polityka prywatności</Link>
          <Link to="/cookies">Pliki cookie</Link>
          <a href={`mailto:${LEGAL_CONFIG.contactEmail}`}>Kontakt</a>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
